/** Display names for the three self-chosen levels (1 to 3, stored on the reader). */
export const LEVELS = ["Beginner", "Intermediate", "Advanced"] as const;

export const LEVEL_HELP = [
  "New to tech. We explain the jargon.",
  "You know the basics and want the gaps filled.",
  "You build things; you just want the new stuff.",
] as const;

/** "4 min ago" / "3 h ago" / "2 d ago", then a short date. Server timestamps are UTC ISO-8601. */
export function when(iso: string): string {
  const t = Date.parse(iso);
  if (Number.isNaN(t)) return "";
  const s = Math.max(0, (Date.now() - t) / 1000);
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.floor(s / 60)} min ago`;
  if (s < 86400) return `${Math.floor(s / 3600)} h ago`;
  if (s < 7 * 86400) return `${Math.floor(s / 86400)} d ago`;
  return new Date(t).toLocaleDateString(undefined, {
    day: "numeric",
    month: "short",
    year: s > 200 * 86400 ? "numeric" : undefined,
  });
}
